import { Badge, Dropdown, Empty, Loading } from '@greenglobal/greencore.fe.common'
import { MenuProps } from '@greenglobal/greencore.fe.common/dist/components/Menu'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie'

import logo from '@/assets/images/apps-icon/logo.svg'
import Icon from '@/components/Icon'
import { DATEFORMAT } from '@/constants/format'
import { ROUTES } from '@/constants/routesConstants'
import { useAppSelector } from '@/state/hooks'
import { getToken, removeItem } from '@/utils/indexDB'
import st from './header.module.scss'
import useNotification from './useNotification'
import { useSelector } from 'react-redux'
import { selectPermissions } from '@/reducers/authentication'
import { checkPermission } from '@/utils/Utils'
import { PERMISSIONS } from '@/constants/permissions'
import { useState } from 'react'
import { isEmpty } from 'lodash'
import { DanhSachThongBao } from '@/types/danh-sach-thong-bao'
import authApiRequest from '@/apis/auth.api'

const cookies = new Cookies()

interface HeaderProps {
  setToggleModal?: React.Dispatch<React.SetStateAction<boolean>>
}

const Header = ({ setToggleModal }: HeaderProps) => {
  const { user } = useAppSelector((state) => state.auth)
  const { data } = useAppSelector((state) => state.notification)
  const { list, handleGetList, isLoadingNoti } = useNotification()
  const permissions = useSelector(selectPermissions)
  const navigate = useNavigate()
  const resetCookies = () => {
    cookies.remove('application_id')
    cookies.remove('user_id')
    removeItem()
  }

  const handleLogout = async () => {
    const access_token = getToken()
    try {
      await authApiRequest.logout(access_token)
    } catch {}
    resetCookies()
    window.location.replace(`${process.env.REACT_APP_DOMAIN_QTUD_URL_API}${ROUTES.TRANG_CHU}?isLogout=true`)
    // window.location.replace(`http://localhost:9000${ROUTES.TRANG_CHU}?isLogout=true`)
  }

  const handleOpenModal = () => {
    setToggleModal?.(true)
  }

  const renderIcon = (type: string) => {
    if (type === 'QUAN_TRONG') return <Icon icon='flag' style={{ fontSize: 16, color: '#F59E0B', marginTop: 12 }} />
    else if (type === 'NHAC_NHO') return <Icon icon='flag' style={{ fontSize: 16, color: '#00AB55', marginTop: 12 }} />
    else if (type === 'CANH_BAO') return <Icon icon='flag' style={{ fontSize: 16, color: '#BB1818', marginTop: 12 }} />
    else return <Icon icon='flag' style={{ fontSize: 16, color: '#000000', marginTop: 12 }} />
  }

  const hanldeGoPageNotification = () => {
    navigate(`${ROUTES.DANH_SACH_THONG_BAO}`)
  }

  const hanldeGoPageNotificationDetail = (id: string | number) => {
    navigate(`${ROUTES.DANH_SACH_THONG_BAO}/${id}`)
  }

  const notificationsItems = !isEmpty(list?.data)
    ? list?.data.map((notification, index) => {
        return {
          key: `noti${index + 1}`,
          label: (
            <div
              style={!notification?.read ? { backgroundColor: '#EAF6FF' } : undefined}
              className={st['dropdown__noti--item']}
              onClick={() => hanldeGoPageNotificationDetail(notification?.id)}
            >
              {renderIcon(notification?.thong_bao_level_enum)}
              <div className={st.noti__msg}>
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 400,
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 3,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {notification?.content}
                </p>
                <p className={st['noti__msg--date']}>{dayjs(notification?.create_at).format(DATEFORMAT.DATE)}</p>
              </div>
            </div>
          )
        }
      })
    : []

  const handleGoBackApp = () => {
    window.location.replace(`${process.env.REACT_APP_DOMAIN_QTUD_URL_API}${ROUTES.TRANG_CHU}?isAdmin=true`)
    // window.location.replace(`http://localhost:9000${ROUTES.TRANG_CHU}?isAdmin=true`)
  }

  const menuItems: MenuProps['items'] = [
    // {
    //   key: 'lock',
    //   label: (
    //     <div style={{ margin: '4px' }} onClick={handleOpenModal}>
    //       <Icon icon='lock' />
    //       <span style={{ marginLeft: '8px' }}>Đổi mật khẩu</span>
    //     </div>
    //   )
    // },
    {
      key: 'logout',
      label: (
        <div style={{ margin: '4px' }} onClick={() => handleLogout()}>
          <Icon icon='logout' />
          <span style={{ marginLeft: '8px' }}>Đăng xuất</span>
        </div>
      )
    }
  ]

  if (checkPermission([PERMISSIONS.HETHONG], permissions)) {
    menuItems.unshift({
      key: 'back',
      label: (
        <div style={{ margin: '4px' }} onClick={handleGoBackApp}>
          <Icon icon='arrow-left' />
          <span style={{ marginLeft: '8px' }}>Về quản lý ứng dụng</span>
        </div>
      )
    })
  }

  const handleOpenChange = (open: any) => {
    if (open) {
      handleGetList()
    }
  }

  const renderLoading = () => {
    return [
      {
        key: 'loading',
        label: (
          <Loading
            loading
            className={st.loading}
            paragraph={{
              rows: 6,
              width: 100
            }}
            size='default'
            style={{
              width: 450
            }}
            type='INDICATOR'
          />
        )
      }
    ]
  }

  const notificationsMenu: MenuProps['items'] = isLoadingNoti
    ? [
        ...(renderLoading() || []),
        {
          key: 'btn',
          label: (
            <div className={st.noti__btn} onClick={hanldeGoPageNotification}>
              xem thêm
            </div>
          )
        }
      ]
    : !isEmpty(notificationsItems)
      ? [
          ...(notificationsItems || []),
          {
            key: 'btn',
            label: (
              <div className={st.noti__btn} onClick={hanldeGoPageNotification}>
                xem thêm
              </div>
            )
          }
        ]
      : [
          {
            key: 'empty',
            label: <Empty simple />
          }
        ]

  return (
    <header className={st.header}>
      <div className={st.header__title}>
        <img src={logo} />
        <span className='title_project'>
          Hệ thống theo dõi việc thực hiện các kết luận thanh tra, kiến nghị của Kiểm toán nhà nước trên địa bàn thành
          phố Đà Nẵng
        </span>
      </div>
      <div className={st.header__user}>
        <Dropdown
          placement='bottomRight'
          className={st.dropdown__noti}
          overlayClassName={st.noti__overlay}
          menu={{ items: notificationsMenu }}
          onOpenChange={(value: boolean) => handleOpenChange(value)}
          trigger={['click']}
          arrow
        >
          <div className={st['header__user--noti']}>
            <Badge count={data || 0} overflowCount={99} size='small' className={st.countNoti}>
              <Icon icon='notification' size='md' color='white' />
            </Badge>
          </div>
        </Dropdown>

        <Dropdown placement='bottomRight' menu={{ items: menuItems }}>
          <div className={st['header__user--info']}>
            <div className={st.avatar} />
            <p className={st.name}>{user?.full_name}</p>
            <Icon icon='arrow-down' style={{ fontSize: 10 }} color='white' />
          </div>
        </Dropdown>
      </div>
    </header>
  )
}

export default Header
